import { render, staticRenderFns } from "./ChoreAssignmentMenu.vue?vue&type=template&id=4229a15c&scoped=true"
import script from "./ChoreAssignmentMenu.vue?vue&type=script&lang=js"
export * from "./ChoreAssignmentMenu.vue?vue&type=script&lang=js"
import style0 from "./ChoreAssignmentMenu.vue?vue&type=style&index=0&id=4229a15c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4229a15c",
  null
  
)

export default component.exports